import { ProcessSelectionConfiguration, ProcessSelectOption } from './../process-selection.model';
import { Component, OnInit } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';

@Component({
  selector: 'app-process-selection',
  templateUrl: './process-selection.component.html',
  styleUrls: ['./process-selection.component.scss']
})
export class ProcessSelectionComponent extends AbstractWidgetComponent implements OnInit {

  processSelectionConfiguration: ProcessSelectionConfiguration;

  constructor(
    public translationService: TranslationService
  ) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key ===  'dashboardConfiguration') {
      this.processSelectionConfiguration = new ProcessSelectionConfiguration(contextChange.value);
    }
  }

  onSetElementAndContext() {
    const config = this.dashboardContext.getContextValue('dashboardConfiguration');
    this.processSelectionConfiguration = new ProcessSelectionConfiguration(config);
  }

  ngOnInit(): void {
  }

  select(entry: ProcessSelectOption) {
    this.dashboardContext.setContextValue('selectedProcessOption', entry);
  }

  getTitle(entry: ProcessSelectOption): string {
    if (entry.titleDictionaryKey != null) {
      return this.translationService.translate(entry.titleDictionaryKey);
    }
    if (entry.titleDictionaryEntry != null) {
      if (entry.titleDictionaryEntry.getValue(this.translationService.language) != null) {
        return entry.titleDictionaryEntry.getValue(this.translationService.language).value;
      } else if (this.translationService.fallbackLanguages.length > 0) {
        return entry.titleDictionaryEntry.getValue(this.translationService.fallbackLanguages[0])?.value;
      }
    }
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
